// @ts-check
import * as serializationUtils from '../../serializationUtils';

var getCollectionSchema = function getCollectionSchema(path) {
  var collectionsSchema = {
    job: {
      csvUrl: {
        parentCollection: 'dataSources',
        field: 'fields'
      },
      equalFilterFunction: {
        parentCollection: 'dataSources'
      },
      diagram: {
        '*': {
          parentCollection: 'items'
        },
        connection: 'connections'
      },
      subdocumentParam: 'parameters'
    }
  };

  if (path.endsWith('.edm')) {
    collectionsSchema.job.biUniverseOutput = {
      biUniverse: {
        relationships: {
          relationship: 'items'
        },
        biUniverseTable: {
          parentCollection: 'tables',
          biUniverseDimension: 'dimensions'
        }
      }
    };
  } else if (path.endsWith('.edx')) {
    // use a function for recursive schema definition
    var getElementSchema = function getElementSchema() {
      return {
        parentCollection: 'elements',
        attribute: 'attributes',
        // recursive
        elementSequence: getElementSchema,
        element: getElementSchema
      };
    };

    collectionsSchema.job.output = {
      element: {
        elementSequence: getElementSchema,
        element: getElementSchema
      }
    };
  } else {
    throw new Error('Unsupported file type.');
  }

  return collectionsSchema;
};
/** @param {string} xml XML content of document
/** @param {string} path Path of the document
 ** @return {object} return the xml document parsed into json
 **/


export var fromXml = function fromXml(xml, path) {
  return serializationUtils.fromXml(xml, getCollectionSchema(path));
};
/** @param {object} state json state of the document
/** @param {string} path Path of the document
 ** @return {string} return XML content of document
 **/

export var toXml = function toXml(state, path) {
  var diagramElements = {
    diagram: true,
    connection: true
  };
  return serializationUtils.toXml(state, function (name) {
    if (diagramElements[name] || name.startsWith('diagram-')) return 'dia:' + name;
    return 'das:' + name;
  }, getCollectionSchema(path));
};